import {
  useEffect,
  useState
} from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { WaitScr } from 'components';
import { setUserData, logout } from 'actions';
import { auth } from 'utilities';

function UserCheck({ children }) {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      auth.setAxiosInterceptors({
        onLogout: () => dispatch(logout())
      });

      auth.handleAuthentication();

      if (auth.isAuthenticated()) {
        const user = await auth.loginInWithToken();

        await dispatch(setUserData(user));
      }
      setLoading(false);
    };

    initAuth();
  }, [dispatch]);

  if (isLoading) {
    return <WaitScr />;
  }

  return children;
}

UserCheck.propTypes = {
  children: PropTypes.any
};

export default UserCheck;
